/**
 * Auto-currency by location: detects visitor country via Shopify browsing context
 * and submits the localization form so Shopify redirects to the appropriate market/currency.
 * Respects manual country selection (sessionStorage flag set by localization-form.js).
 */
(function () {
  const config = window.ShopifyAutoCurrency;
  if (!config || !config.currentCountry) return;

  if (sessionStorage.getItem('userChoseCountry') === '1') return;

  fetch('/browsing_context_suggestions.json')
    .then(response => response.json())
    .then(data => {
      const detected = data.detected_values && data.detected_values.country;
      if (!detected) return;

      const detectedCode = (detected.iso_code || detected.handle || '').toUpperCase();
      if (!detectedCode) return;

      const currentCountry = (config.currentCountry || '').toUpperCase();
      if (detectedCode === currentCountry) return;

      const input = document.querySelector('input[name="country_code"]');
      if (!input || !input.form) return;

      input.value = detectedCode;
      sessionStorage.setItem('userChoseCountry', '1');
      input.form.submit();
    })
    .catch(error => console.error('Auto-currency detection failed:', error));
})();
